import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Select from '../../Shared/UI/Select/components/Select';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useTagState, useTagActions } from './TagContext';

import { allowTaggingRule } from './restApi';

const NewAllowedTaggingRuleForm = () => {
  const state = useTagState();
  const {
    onResponse,
    onError,
    updateSelectedTagTypeOnNewAllowedTaggingRule,
    updateSelectedTaggableTypeOnNewAllowedTaggingRule,
  } = useTagActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    allowTaggingRule({
      onResponse,
      onError,
      body: {
        authenticityToken,
        tagId: state?.newAllowedTaggingRuleForm?.tagId,
        tagType: state?.newAllowedTaggingRuleForm?.tagType,
        taggableType: state?.newAllowedTaggingRuleForm?.taggableType,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Tag Type" id="tagType">
        <Select
          value={state?.newAllowedTaggingRuleForm?.tagType || ''}
          onChange={(e) => updateSelectedTagTypeOnNewAllowedTaggingRule(e.target.value)}
        >
          {(state?.tagTypeOptions || []).map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <Field label="Taggable Type" id="taggableType">
        <Select
          value={state?.newAllowedTaggingRuleForm?.taggableType || ''}
          onChange={(e) => updateSelectedTaggableTypeOnNewAllowedTaggingRule(e.target.value)}
        >
          {(state?.taggableTypeOptions || []).map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button type="submit">Allow Tagging Rule</Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewAllowedTaggingRuleForm;
